"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = _interopRequireDefault(require("./../components/localization"));

// This is the one who uses the runtime config to get the translations from window (compile time translations)
var RuntimeLocalizationContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(RuntimeLocalizationContainer, _Component);

  function RuntimeLocalizationContainer() {
    (0, _classCallCheck2["default"])(this, RuntimeLocalizationContainer);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RuntimeLocalizationContainer).apply(this, arguments));
  }

  (0, _createClass2["default"])(RuntimeLocalizationContainer, [{
    key: "render",
    value: function render() {
      var rest = (0, _extends2["default"])({}, this.props);
      var translationKeys = typeof window !== "undefined" && window.runtimeTranslations;
      return _react["default"].createElement(_localization["default"], (0, _extends2["default"])({
        retrieving: false,
        translationKeys: translationKeys,
        error: null
      }, rest));
    }
  }]);
  return RuntimeLocalizationContainer;
}(_react.Component);

RuntimeLocalizationContainer.propTypes = {
  retrieving: _propTypes["default"].bool,
  translationKeys: _propTypes["default"].object,
  error: _propTypes["default"].string,
  actions: _propTypes["default"].object
};
var _default = RuntimeLocalizationContainer;
exports["default"] = _default;